import React from "react";
import { useXScale, useYScale } from "@mui/x-charts";
import { styled } from "@mui/material/styles";
import { getLocalisationVal } from "@/utils/localizationUtil";
import { CommonFonts, Colors } from "@/theme";

const RECT_WIDTH = 43;
const RECT_HEIGHT = 16;

const StyledText = styled("text")(({ theme }) => ({
  ...CommonFonts.darkBoldFont10,
  fill: Colors.GRAY_DARK,
}));

const StyledRect = styled("rect")(({ theme }) => ({
  width: RECT_WIDTH,
  height: RECT_HEIGHT,
  fill: Colors.WHITE,
  stroke: Colors.GRAY_BORDER,
}));

const DrawingCost = ({ costData, localization }) => {
  const yAxisScale = useYScale("yCost");
  const xAxisScale = useXScale("xCost");

  const xData = costData
    ?.filter((item) => !!item.price)
    ?.map((item) => item.time);
  const yData = costData
    ?.filter((item) => !!item.price)
    ?.map((item) => parseFloat(getLocalisationVal(localization, item.price)));

  return xData.map((x, id) => {
    const isLargerThanBefore = yData[id] >= yData?.[id - 1];

    const yOrigin = isLargerThanBefore
      ? yAxisScale(yData[id]) - 5
      : yAxisScale(yData[id]) + 18;
    const xOrigin = xAxisScale(x);
    return (
      <React.Fragment key={`drawing-cost-${id}`}>
        <StyledRect
          x={xOrigin - RECT_WIDTH / 2}
          y={yOrigin - RECT_HEIGHT + 2}
          rx={10}
        />
        <StyledText
          x={xOrigin}
          y={yOrigin}
          textAnchor="middle"
          dominantBaseline="text-after-edge"
        >
          {getLocalisationVal(localization, yData[id])}
        </StyledText>
      </React.Fragment>
    );
  });
};

export default DrawingCost;
